export default function Send() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2446_81)">
                <path d="M18.3932 2.31934L12.5599 18.986L9.22656 11.486M18.3932 2.31934L1.72656 8.15267L9.22656 11.486M18.3932 2.31934L9.22656 11.486" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2446_81">
                    <rect width="20" height="20" fill="currentColor" transform="translate(0.0585938 0.652344)" />
                </clipPath>
            </defs>
        </svg>
    )
}